export default __webpack_public_path__ + "static/media/AdminIcon.60377b84.svg";